import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaFilePdf, FaFileExcel } from 'react-icons/fa';
import { toast } from 'react-toastify';
import RelNegociosService from '~/Services/GES/RelNegociosService';
import { gerarTimestamp, mensagemErro } from '../helpers';

// Dispara o download de um blob com nome de arquivo dinâmico (paridade BotoesExport CentroCusto).
const dispararDownload = (blob, nomeArquivo) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nomeArquivo;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// payload = montarPayloadFiltro(filtros) — idêntico ao usado em /gerar (controller compartilha request).
const BotoesExport = ({ payload, desabilitado }) => {
  const [exportandoPdf, setExportandoPdf] = useState(false);
  const [exportandoExcel, setExportandoExcel] = useState(false);

  const handleExportarPdf = async () => {
    setExportandoPdf(true);
    try {
      const blob = await RelNegociosService.exportarPdf(payload);
      dispararDownload(blob, `ListaNegocios_${gerarTimestamp()}.pdf`);
    } catch (err) {
      toast.error(mensagemErro(err, 'Erro ao exportar PDF.'));
    } finally {
      setExportandoPdf(false);
    }
  };

  const handleExportarExcel = async () => {
    setExportandoExcel(true);
    try {
      const blob = await RelNegociosService.exportarExcel(payload);
      dispararDownload(blob, `ListaNegocios_${gerarTimestamp()}.xlsx`);
    } catch (err) {
      toast.error(mensagemErro(err, 'Erro ao exportar Excel.'));
    } finally {
      setExportandoExcel(false);
    }
  };

  return (
    <>
      <Button
        variant="danger"
        className="mr-2"
        onClick={handleExportarPdf}
        disabled={desabilitado || exportandoPdf}
      >
        <FaFilePdf className="mr-1" />
        {exportandoPdf ? 'Gerando PDF...' : 'Exportar PDF'}
      </Button>
      <Button
        variant="success"
        onClick={handleExportarExcel}
        disabled={desabilitado || exportandoExcel}
      >
        <FaFileExcel className="mr-1" />
        {exportandoExcel ? 'Gerando Excel...' : 'Exportar Excel'}
      </Button>
    </>
  );
};

export default BotoesExport;
